import React, { useEffect } from "react";
import Header from "../home/header";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Login from "../home/login_form";
import feature from "../../img/reps.svg";
import { X } from "lucide-react";
import { ApiClient } from "../../utils/api-client";
import UTILS from "../../utils/commons";

const StaffDetail = ( props ) => {
  let navigate = useNavigate();
  let location = useLocation();
  var data = location.state;
  var loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
  const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
  var { id } = useParams();

  const [ issues, setIssues ] = React.useState( [] );
  const [ loading, setLoading ] = React.useState( false );
  const [ productData, setProductData ] = React.useState( [] );
  const [ recentTransactions, setRecentTransactions ] = React.useState( [] );
  const loadStaffIssues = async () => {
    const issuesResult = await apiClient.get( `issues/profile/${id}` );
    if ( issuesResult.status === 200 || issuesResult.status === 201 ) {
      const issuesData = issuesResult.data;
      setIssues( issuesData );
      console.log( "🚀 ~ StaffDetail ~ loadStaffIssues ~ issuesData:", issuesData )
      prepareData( issuesData );
    }
    else {
      console.log( "Failed to load staff issues" )
    }
  }

  const prepareData = ( issues ) => {
    const result = []
    const products = issues.map( d => d.product )
    const productIds = products.map( p => p.id );
    const uniqueProductIds = [ ...new Set( productIds ) ];
    const uniqueProducts = uniqueProductIds.map( id => products.find( p => p.id === id ) );
    uniqueProducts.forEach( up => {
      const dataItems = issues.filter( d => d.product.id === up.id );
      let item = {
        product: up,
        totalIssued: 0,
        totalSold: 0,
        currentStock: 0,
        averageSellingPrice: 0,
        totalStockValue: 0,
        totalSoldValue: 0,
        items: []
      };
      let weightedPriceTotal = 0;
      dataItems.forEach( d => {
        item.totalIssued += Number( d.quantity );
        weightedPriceTotal += ( Number( d.quantity ) * Number( d.sellingPrice || 0 ) );
        item.totalSold = Math.max( item.totalSold, Number( d.sold || 0 ) );
        item.items.push( { invoiceNumber: d.invoiceNumber, quantity: d.quantity, createdAt: d.createdAt, id: d.id } );
      }
      );
      item.averageSellingPrice = item.totalIssued ? weightedPriceTotal / item.totalIssued : 0;
      item.currentStock = Math.max( item.totalIssued - item.totalSold, 0 );
      item.totalStockValue = item.currentStock * item.averageSellingPrice;
      item.totalSoldValue = item.totalSold * item.averageSellingPrice;
      result.push( item );
    } );
    console.log( "🚀 ~ prepareData ~ result:", result )
    setProductData( result );
  }
  const loadData = async () => {
    setLoading( true );
    await Promise.all( [ loadStaffIssues(), loadRecentTransactions() ] );
    setLoading( false );
  }

  const loadRecentTransactions = async () => {
    try {
      const req = await apiClient.get( '/transactions', { params: { profileId: id } } );
      if ( req.status === 200 && Array.isArray( req.data ) ) {
        const sortedTransactions = [ ...req.data ].sort( ( a, b ) => new Date( b.createdAt ).getTime() - new Date( a.createdAt ).getTime() );
        setRecentTransactions( sortedTransactions );
      }
      else {
        setRecentTransactions( [] );
      }
    }
    catch ( e ) {
      console.log( 'Failed to load staff recent transactions', e );
      setRecentTransactions( [] );
    }
  }


  useEffect( () => {
    loadData();
  }, [] )

  return ( <>
    <Header auth={loginState} />
    <section className="container shadow-md p-4 justify-start mt-8">
      <div className="w-full mb-4 flex justify-between items-start">
        <div>
          <p className="text-sm uppercase tracking-wide text-gray-500">Staff Profile</p>
          <h2 className="text-2xl font-semibold text-gray-800">Staff Details</h2>
        </div>
        <button className="p-1 rounded-md hover:bg-gray-100 transition-colors" onClick={() => { navigate( -1, { replace: true } ) }}><X className="text-primary-500 hover:text-secondary-500" /></button>
      </div>

      <div className="w-full rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 items-start">
          <div className="flex flex-col sm:flex-row lg:flex-col items-center lg:items-start gap-4">
            <img
              id="preview"
              alt={data?.firstName || data?.auth?.firstName}
              src={data.profileImage || feature}
              className="h-28 w-28 rounded-full object-cover border-2 border-primary-200 shadow-sm mx-auto"
            />
            <div className="text-center sm:text-left lg:text-left">
              <p className="text-xl font-semibold text-gray-800">{`${data?.firstName || data?.auth?.firstName || ''} ${data.lastName || data?.auth?.lastName || ''}`.trim()}</p>
              <p className="text-sm text-gray-500 mt-1">{data?.auth?.email}</p>
              <p className="inline-block mt-3 text-xs font-semibold uppercase tracking-wide text-primary-700 bg-primary-100 px-2.5 py-1 rounded-full">{data?.role || data?.auth?.role}</p>
            </div>
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Phone</p>
              <p id="phone" className="text-secondary-700 font-medium mt-1">{data?.phone || 'N/A'}</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Service Area</p>
              <p id="service_area" className="text-secondary-700 font-medium mt-1">{data.serviceArea || 'N/A'}</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Products Managed</p>
              <p className="text-secondary-700 font-semibold mt-1">{UTILS.thousandSeparator( productData.length )}</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Recent Transactions</p>
              <p className="text-secondary-700 font-semibold mt-1">{UTILS.thousandSeparator( recentTransactions.length )}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-2xl mt-8">Inventory Status</div>
      <div className="mt-4 border rounded-md overflow-x-auto">
        <table className="w-full min-w-[56rem] text-left">
          <thead className="bg-gray-100">
            <tr className="text-xs uppercase tracking-wide text-gray-600">
              <th className="py-3 px-3 font-semibold">Product</th>
              <th className="py-3 px-3 font-semibold text-right">Issued Qty</th>
              <th className="py-3 px-3 font-semibold text-right">Sold Qty</th>
              <th className="py-3 px-3 font-semibold text-right">Current Stock</th>
              <th className="py-3 px-3 font-semibold text-right">Selling Price</th>
              <th className="py-3 px-3 font-semibold text-right">Stock Value</th>
              <th className="py-3 px-3 font-semibold text-right">Total Sales</th>
            </tr>
          </thead>
          <tbody>
            {productData.length ? productData.map( ( item, index ) => (
              <tr key={index} className="border-t border-gray-200 text-sm text-gray-700">
                <td className="py-3 px-3 font-medium text-gray-800">{item.product.productName} - {item.product.packSize}</td>
                <td className="py-3 px-3 text-right">{UTILS.thousandSeparator( item.totalIssued )}</td>
                <td className="py-3 px-3 text-right">{UTILS.thousandSeparator( item.totalSold )}</td>
                <td className="py-3 px-3 text-right">{UTILS.thousandSeparator( item.currentStock )}</td>
                <td className="py-3 px-3 text-right">{UTILS.thousandSeparator( Math.round( item.averageSellingPrice ) )}</td>
                <td className="py-3 px-3 text-right font-semibold text-secondary-700">{UTILS.thousandSeparator( Math.round( item.totalStockValue ) )}</td>
                <td className="py-3 px-3 text-right font-semibold text-green-700">{UTILS.thousandSeparator( Math.round( item.totalSoldValue ) )}</td>
              </tr>
            ) ) : (
              <tr>
                <td colSpan={7} className="py-6 text-center text-sm text-gray-500">No inventory data available for this staff member.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="text-2xl mt-8">Recent Activities</div>
      <div className="mt-4 border rounded-md overflow-x-auto">
        <table className="w-full min-w-[52rem] text-left">
          <thead className="bg-gray-100">
            <tr className="text-xs uppercase tracking-wide text-gray-600">
              <th className="py-3 px-3 font-semibold">Date</th>
              <th className="py-3 px-3 font-semibold">Customer</th>
              <th className="py-3 px-3 font-semibold">Type</th>
              <th className="py-3 px-3 font-semibold text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4} className="py-6 text-center text-sm text-gray-500">Loading recent activities...</td>
              </tr>
            ) : recentTransactions.length ? recentTransactions.map( transaction => (
              <tr key={transaction.id} className="border-t border-gray-200 text-sm text-gray-700">
                <td className="py-3 px-3">{new Date( transaction.createdAt ).toLocaleDateString()}</td>
                <td className="py-3 px-3 font-medium text-gray-800">{transaction.customer ? `${transaction.customer.name || ''}`.trim() : 'N/A'}</td>
                <td className="py-3 px-3">{Number( transaction.type ) === 0 ? 'Cash Sale' : 'Credit Sale'}</td>
                <td className="py-3 px-3 text-right font-semibold text-secondary-700">{UTILS.thousandSeparator( Number( transaction.totalAmount || 0 ) )}</td>
              </tr>
            ) ) : (
              <tr>
                <td colSpan={4} className="py-6 text-center text-sm text-gray-500">No recent activities</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  </> )
}
export default StaffDetail;
